import { Trans, useTranslation } from "react-i18next"

interface Props {
  headingKey: string
  subheadingKey?: string
  values?: Record<string, string | number>
}

export default function StepHeading({
  headingKey,
  subheadingKey,
  values,
}: Props) {
  const { i18n } = useTranslation()

  return (
    <div className="animate-fade-up space-y-2">
      <h1 className="vm-heading">
        <Trans
          components={{ colored: <span className="vm-highlight" /> }}
          i18nKey={headingKey}
          values={values}
        />
      </h1>

      {subheadingKey && i18n.exists(subheadingKey) && (
        <p className="vm-subheading">
          <Trans
            components={{
              bold: <strong className="font-semibold text-vm-ink" />,
            }}
            i18nKey={subheadingKey}
            values={values}
          />
        </p>
      )}
    </div>
  )
}
